// --- React
import React from 'react';
// --- UI Component
import { CommentBodyDetailsRow } from './index.jsx';

/**
 * DetailsRow Component
 *
 * This component is responsible for rendering different types of details rows
 * based on the provided data type.
 * It uses the CommentBodyDetailsRow component for rendering.
 *
 * @param {string} dataType - The type of data to be rendered in the details row.
 * * @returns {Function} - A renderer function that returns the appropriate details row component.
 * @param rowData
 */
export const DetailsRow = ({ dataType, data }) => {
    if (dataType === 'sharedSections' || dataType === 'comments') {
        return <CommentBodyDetailsRow data={data} />;
    }
    return null;
};
